import { isEmpty } from '@/src/utils/generalUtils'

const NA = 'NA'

export interface NativeAppMetadata {
    'app-agent': string
    'app-version-name': string
    'app-platform': string
    'app-version-code': string
}

/**
 * Native app metadata forwarded by the RN WebView. The native layer injects the
 * same values it sends as request headers into `window.androidData` / `window.iosData`
 */
const getNativeAppMetadata = (): NativeAppMetadata => {
    if (typeof window === 'undefined') {
        return { 'app-agent': NA, 'app-version-name': NA, 'app-platform': NA, 'app-version-code': NA }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const source: any = !isEmpty(window.androidData) ? window.androidData : window.iosData
    const data = source || {}

    return {
        'app-agent': data['app-agent'] || NA,
        'app-version-name': data['app-version-name'] || NA,
        'app-platform': data['app-platform'] || NA,
        'app-version-code': data['app-version-code'] || NA
    }
}

export default getNativeAppMetadata
